/**
* Testimonials JS
* -----------------------------------------------------------------------------
*
* All the JS for the Testimonials component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';

( function( app ) {
  const COMPONENT = {
    className: 'testimonials',
    selector: function() {
      return '.' + this.className;
    },

    init: function() {
      const $sliders = $( '.splide--testimonials' );
      if ( !$sliders.length ) return;

      $sliders.each( function( index, element ) {
        // initialize Splide
        const splideInstance = new Splide( element, {
          type: 'loop',
          gap: '32px',
          arrows: false,
          perPage: 2,
          perMove: 1,
          pagination: false,
          speed: 800,
          breakpoints: {
            1269: {
              perPage: 2,
              gap: '16px',
            },
            768: {
              perPage: 1,
            },
          },
        } ).mount();

        // hook up external arrows
        const $slider = $( element );
        const $controls = $( `[data-splide-controls="#${$slider.attr( 'id' )}"]` );

        $controls.find( '.splide__arrow--prev' ).on( 'click', () => splideInstance.go( '<' ) );
        $controls.find( '.splide__arrow--next' ).on( 'click', () => splideInstance.go( '>' ) );
      } );
    },

    finalize: function() {},
  };

  app.registerComponent( 'testimonials', COMPONENT );
} )( app );
